<template>
    <el-drawer :visible.sync="localVisible" direction="rtl" :before-close="handleClose" :append-to-body="true"
        :size="screenWidth < 768 ? '100%' : '450px'" :show-close="false" custom-class="order-details-drawer" :with-header="false">
        <!-- 自定义头部 -->
        <div class="drawer-header">
            <div class="title">ORDER DETAILS</div>
            <i class="el-icon-close close-btn" @click="handleClose"></i>
        </div>

        <!-- 内容区域 -->
        <div class="drawer-body">
            <!-- 订单编号与总价 -->
            <div class="order-meta">
                <span class="order-id">{{ orderInfo.orderNum }}</span>
                <span class="order-total">Total: $ {{ orderInfo.totalAmount }}</span>
            </div>

            <!-- 商品列表 -->
            <div class="product-list">
                <div v-for="(item, index) in orderInfo.details" :key="index" class="product-item">
                    <div class="p-image">
                        <img :src="imageUtils(websiteImg, item.image)" alt="Product">
                    </div>
                    <div class="p-info">
                        <div class="p-name">{{ item.productName }}</div>
                        <!-- <div class="p-row">
                            <span class="label">Model: </span>
                            <span class="value">{{ item.model }}</span>
                        </div> -->
                        <div class="p-row">
                            <span class="label">Fabric: </span>
                            <span class="value">{{ item.fabric }}</span>
                        </div>
                        <div class="p-row">
                            <span class="label">Width(cm) : </span>
                            <span class="value">{{ item.width }}</span>
                        </div>
                        <div class="p-row">
                            <span class="label">Height(cm) : </span>
                            <span class="value">{{ item.height }}</span>
                        </div>
                        <div class="p-row price-row">
                            <div>
                                <span class="label">Qty: </span>
                                <span class="value">{{ item.quantity }}</span>
                            </div>
                            <div class="p-price">$ {{ item.price }}</div>
                        </div>
                    </div>
                </div>
            </div>

            <el-divider class="custom-divider"></el-divider>

            <!-- 地址信息 -->
            <div class="section address-section">
                <div class="section-title">ADDRESS</div>
                <div class="addr-content" v-if="orderInfo.address">
                    <div class="addr-name">{{ orderInfo.address.firstName }} {{ orderInfo.address.lastName }}</div>
                    <div class="addr-detail">
                        {{ orderInfo.address.address ? orderInfo.address.address + ',' : '' }} {{ orderInfo.address.apt
                            ? orderInfo.address.apt + ',' : '' }}{{ orderInfo.address.city ? orderInfo.address.city + ',' :
                        '' }} {{ orderInfo.address.state ? orderInfo.address.state + ',' : '' }} {{
                            orderInfo.address.postCode ? orderInfo.address.postCode + ',' : '' }} {{
                            orderInfo.address.country }}
                    </div>

                    <div class="addr-phone">{{ orderInfo.address.phone }}</div>
                </div>
            </div>

            <el-divider class="custom-divider"></el-divider>

            <!-- 订单状态时间轴 -->
            <div class="section status-section">
                <div class="section-title">ORDER STATUS</div>
                <el-timeline>
                    <el-timeline-item v-for="(activity, index) in statusList" :key="index"
                        :color="statusValue >= activity.status ? '#43342E' : '#E4E7ED'"
                        v-show="activity && activity.statusTime"
                        :class="{ 'active-node': statusValue >= activity.status, 'grey-node': statusValue < activity.status }"
                        hide-timestamp>
                        <div class="timeline-content">
                            <span class="status-text">{{ activity.status > 2 ? activity.context :
                                timeline[activity.status].content }}</span>
                            <span class="status-time"> {{ activity.statusTime ? activity.statusTime : '' }} </span>
                        </div>
                    </el-timeline-item>
                </el-timeline>
            </div>
        </div>
    </el-drawer>
</template>

<script>
import { orderDetails } from '@/api/member';
import { imageUtils } from '@/utils/imageUtil';
import utils from '@/utils/util.js';
import { mapGetters } from "vuex";
export default {
    name: "OrderDrawer",
    props: ['visible', 'orderId'],

    data() {
        return {
            Loading: false,
            websiteImg: utils.websiteImg,
            orderInfo: {},
            statusList: [],
            statusValue: 0,
            timeline: [
                { content: 'Order pending review', status: 0 },
                { content: 'In production', status: 1 },
                { content: 'Order shipped', status: 2 },

            ]
        };
    },
    watch: {
        orderId(newVal) {
            if (newVal) {
                this.getOrderDetails();
            }
        }
    },
    computed: {
        localVisible: {
            get() { return this.visible; },
            set(val) { this.$emit('update:visible', val); }
        },
        isEdit() {
            return !!this.formData.wdId;
        },
        ...mapGetters("app", ["getScreenWidth", "isMobile"]),
        screenWidth() {
            return this.getScreenWidth;

        },
    },
    methods: {
        imageUtils,
        handleClose() {
            this.localVisible = false;
            this.$emit('closeHandler');
        },
        async getOrderDetails() {
            this.Loading = true
            await orderDetails({ orderId: this.orderId }).then(res => {
                if (res.code == 1) {
                    this.orderInfo = res.data.dataDetails
                    this.statusValue = res.data.status - 0
                    this.statusList = res.data.statusList

                }
                this.Loading = false
            });
        }
    }
};
</script>

<style>
.el-timeline-item__wrapper {
    width: 100%;
    top: 0;
}
</style>
<style lang="scss" scoped>
/* 全局字体设置，模拟截图中的衬线体风格 */
.order-details-drawer div {
    font-family: "NotoSerif", sans-serif;
    color: #333;
}

/* 头部样式 */
.drawer-header {
    padding: 20px 20px 10px;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .title {
        font-size: 18px;
        font-weight: bold;
        letter-spacing: 1px;
        text-transform: uppercase;
    }

    .close-btn {
        font-size: 20px;
        cursor: pointer;
        color: #666;

        &:hover {
            color: #000;
        }
    }
}

.drawer-body {
    padding: 0 20px 40px;
    height: calc(100vh - 60px);
    overflow-y: auto;
}

/* 订单号与总价 */
.order-meta {
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin-top: 20px;
    margin-bottom: 30px;
    font-weight: bold;
    font-size: 16px;

    .order-total {
        font-size: 16px;
    }
}

/* 商品列表 */
.product-item {
    display: flex;
    margin-bottom: 25px;

    .p-image {
        width: 100px;
        height: 100px;
        background-color: #f0f0f0;
        margin-right: 15px;
        flex-shrink: 0;

        img {
            width: 100%;
            height: 100%;
            object-fit: cover;
        }
    }

    .p-info {
        flex: 1;
        font-size: 14px;

        .p-name {
            font-weight: bold;
            margin-bottom: 8px;
            font-family: "NotoSerif", serif;
        }

        .p-row {
            display: flex;
            margin-bottom: 4px;
            line-height: 1.4;

            .label {
                color: #666;
            }

            .value {
                font-weight: 500;
                color: #000;
            }
        }

        .price-row {
            justify-content: space-between;
            margin-top: 5px;
            align-items: center;

            .p-price {
                font-weight: bold;
            }
        }
    }
}

/* 分割线 */
.custom-divider {
    margin: 25px 0;
    background-color: #eee;
}

/* 通用标题 */
.section-title {
    font-size: 16px;
    font-weight: bold;
    text-transform: uppercase;
    letter-spacing: 0.5px;
    margin-bottom: 15px;
}

/* 地址部分 */
.address-section {
    .addr-content {
        font-size: 14px;
        line-height: 1.6;
        color: #333;

        .addr-name {
            margin-bottom: 5px;
            font-weight: 500;
        }
    }
}

/* 状态时间轴 */
.status-section {
    ::v-deep .el-timeline-item__tail {
        border-left: 1px solid #E4E7ED;
        top: 2px;
    }

    .timeline-content {
        display: flex;
        width: 100%;
        justify-content: space-between;
        align-items: flex-start;
        font-size: 12px;
    }

    /* 激活状态（第一条）样式 */
    .active-node {
        .status-text {
            width: 69%;
            font-weight: bold;
            color: #43342E;
        }

        .status-time {
            font-weight: bold;
            color: #43342E;
        }
    }

    /* 非激活状态样式 */
    .grey-node {

        .status-text,
        .status-time {
            color: #999;
        }
    }
 
}
   @media (max-width: 768px) {
        .drawer-header .title,.order-meta,.drawer-body div,.order-total{ 
            font-size: 4rem !important;
        }
        .product-item .p-image{ 
            width: 25rem;
            height: 25rem;
            padding-right: 2rem;
         }
         .status-time,.status-text{
            font-size: 3.5rem !important;
         }
    }
</style>